<template>
	<div class="flex notification-menu mr-4">
		<vs-dropdown v-if="unreadNotifications" vs-custom-content vs-trigger-click class="cursor-pointer">
			<feather-icon
				icon="BellIcon"
				class="cursor-pointer mt-2 sm:mr-6 mr-2"
				:badge="quantidadeNaolidas"
			></feather-icon>
			<vs-dropdown-menu
				id="notification-dropdown"
				class="notification-dropdown dropdown-custom vx-navbar-dropdown"
			>
				<div class="notification-top text-center p-5 bg-primary text-white">
					<h3 class="text-white">NOTIFICAÇÕES</h3>
					<p v-if="quantidadeNaolidas > 0" class="opacity-75">
						{{ quantidadeNaolidas }} {{ quantidadeNaolidas == 1 ? 'notificação não lida' : 'notificações não lidas'}}.
					</p>
					<p v-else class="opacity-75">
						Todas as notificações foram lidas.
					</p>
				</div>

				<VuePerfectScrollbar
					ref="mainSidebarPs"
					class="scroll-area--nofications-dropdown p-0 mb-10"
					:settings="settings"
				>
					<ul class="bordered-items">
						<li
							v-for="ntf in unreadNotifications"
							:key="ntf.pk"
							class="flex justify-between px-4 py-4 notification cursor-pointer"
							@click="() => verNotificacao(ntf)"
						>
							<div class="flex items-start">
								<div class="mx-2">
									<h5
										class="font-medium block notification-title uppercase"
										>{{ ntf.assunto }}</h5>

									<p class="notification-message">{{ ntf.mensagem }}</p>
								</div>
							</div>
							<small class="mt-1 whitespace-no-wrap">{{
								elapsedTime(ntf.criadoEm)
							}}</small>
						</li>
					</ul>
				</VuePerfectScrollbar>
				<div
					class="
							checkout-footer
							fixed
							bottom-0
							rounded-b-lg
							text-primary
							w-full
							p-2
							font-semibold
							text-center
							border
							border-b-0
							border-l-0
							border-r-0
							border-solid
							d-theme-border-grey-light
							cursor-pointer"
					@click="navigateToNotificacoes"
				>
					<span>VER TODAS AS NOTIFICAÇÕES</span>
				</div>
			</vs-dropdown-menu>
		</vs-dropdown>

		<popup-notificacao-ver
			:active.sync="popupVerNotificacao"
			:closed="haddlerFecharNotificacaoVer"
			:notificacao="notificacaoVer"
		/>
	</div>
</template>

<script>
import { mapState, mapActions } from "vuex";

import Colaborador from "../../models/Colaborador";
import Notificacao from "../../models/Notificacao";
import PopupNotificacaoVer from "../../views/notificacao/components/popup_notificacao_ver/PopupNotificacaoVer";


export default {
	data() {
		return {
			notificacaoVer: null,
			popupVerNotificacao: false,
			settings: {
				// perfectscrollbar settings
				wheelSpeed: 0.2
			}
		};
	},
	components: {
		PopupNotificacaoVer
	},
	computed: {
		quantidadeNaolidas() {
			return this.unreadNotifications.length;
		},
		empresaPk() {
			try {
				return this.$route.params.empresaPk;
			} catch (error) {
				return null;
			}
		},
		...mapState(["unreadNotifications"])
	},
	methods: {
		async getNotificacoes() {
			try {
				const colaborador = Colaborador.getColaborador();

				const { notificacoes } = await Notificacao.getNotificacoes(
					this.empresaPk,
					colaborador.pk,
					{
						limit: 10,
						lida: false
					}
				);

				this.setUnreadNotifications(notificacoes);
			} catch (error) {
				console.error(error);
			}
		},
		elapsedTime(startTime) {
			let x = new Date(startTime);
			let now = new Date();
			var timeDiff = now - x;
			timeDiff /= 1000;

			var seconds = Math.round(timeDiff);
			timeDiff = Math.floor(timeDiff / 60);

			var minutes = Math.round(timeDiff % 60);
			timeDiff = Math.floor(timeDiff / 60);

			var hours = Math.round(timeDiff % 24);
			timeDiff = Math.floor(timeDiff / 24);

			var days = Math.round(timeDiff % 365);
			timeDiff = Math.floor(timeDiff / 365);

			var years = timeDiff;


			if (years > 0) {
				return "há " + years + (years == 1 ? " ano" : " anos");
			} else if (days > 0) {
				return "há " + days + (days == 1 ? " dia" : " dias");
			} else if (hours > 0) {
				return "há " + hours + (hours == 1 ? " hora" : " horas");
			} else if (minutes > 0) {
				return "há " + minutes + (minutes > 1 ? " min. " : " min. ");
			} else if (seconds > 0) {
				return (
					"há " + (seconds > 1 ? `poucos seg.` : "agora")
				);
			}

			return "agora";
		},
		navigateToNotificacoes() {
			const $body = document.querySelector("body");
			$body.click();

			try {
				if (this.$route.name !== "empresa-notificacao-listar") {
				this.$navigate({
					name: "empresa-notificacao-listar",
					params: { empresaPk: this.empresaPk }
				});
			}

			} catch (error) {
				return null;
			}
		},
		verNotificacao(notificacao) {
			this.notificacaoVer = notificacao;
			this.popupVerNotificacao = true;

			const $body = document.querySelector("body");
			$body.click();
		},
		haddlerFecharNotificacaoVer() {
			this.notificacaoVer = null;
			this.popupVerNotificacao = false;
		},
		...mapActions(["setUnreadNotifications"])
	},
	watch: {
		$route() {
			this.getNotificacoes();
		}
	},
	created() {
		this.getNotificacoes();
	}
};
</script>

<style lang="scss" src="./notification.scss"></style>
